import { InquiriesItemType } from '../../api/apiConfig';

const ADD_NEW_ITEM = 'inquiriesItem/ADD_NEW_ITEM' as const;
const ADD_PREV_ITEMS = 'inquiriesItem/ADD_PREV_ITEMS' as const;

export interface InquiriesItem {
  newItem: InquiriesItemType | null;
  prevItems: InquiriesItemType[];
}

export const addNewItem = (payload: InquiriesItemType) => ({
  type: ADD_NEW_ITEM,
  payload: payload,
});

export const addPrevItems = (payload: InquiriesItemType[]) => ({
  type: ADD_PREV_ITEMS,
  payload: payload,
});

type InquiriesItemAction =
  | {
      type: typeof ADD_NEW_ITEM;
      payload: InquiriesItemType;
    }
  | {
      type: typeof ADD_PREV_ITEMS;
      payload: InquiriesItemType[];
    };

const initialState: InquiriesItem = {
  newItem: null,
  prevItems: [],
};
const inquiriesItemReducer = (
  state: InquiriesItem = initialState,
  action: InquiriesItemAction
): InquiriesItem => {
  switch (action.type) {
    case ADD_NEW_ITEM:
      console.log('payload:::', action.payload);
      return { ...state, newItem: action.payload };

    case ADD_PREV_ITEMS:
      console.log('payload:::', action.payload);
      return { ...state, prevItems: action.payload };

    default:
      return state;
  }
};

export default inquiriesItemReducer;
